module.exports = __webpack_public_path__ + "static/media/remind.bea513e0.png";